import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {APP, THEME} from "../../app/consts";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";

export class ThemesToggleClickEvent extends BaseAnalyticsEvent {
  source: APP.ANALYTICS.SOURCES;
  isActive: Boolean;

  constructor(params: ThemesToggleClickEvent) {
    super('', 'click', 'old-themes');

    this.isActive = params.isActive;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.clickType = this.isActive ? ANALYTICS.THEMES.dark : ANALYTICS.THEMES.light;
    properties.source = this.source;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();
    const theme: Number = this.isActive ? THEME.DARK :THEME.LIGHT;

    return new GoogleAnalyticsEventModel(eventName, {theme})
  }
}
